import React from 'react';

// Layout
import { Header, Footer, ScrollToTopPigeon } from '../../components/layout';

// Sections
import { 
  HeroSection, 
  Sobre, 
  Agenda, 
  Doacoes, 
  EspacoDaPalavra as Palavra, 
  // Evento, 
  InstagramFeed
} from '../../components/sections';

// Features
import { CookieConsent } from '../../components/features';

function Home() {
  return (
    <>
      <Header />
      <HeroSection />
      {/* <Evento /> */}
      <Sobre />
      <Agenda />
      <Doacoes />
      <Palavra />
      <InstagramFeed />
      <CookieConsent />
      <ScrollToTopPigeon />
      <Footer />
    </>
  );
}

export default Home;
